/**
 * @generated SignedSource<<b4bc34866fed4f646968c20afe39ad2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetIntegrationPushAppyInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAPushAppyMutation$variables = {
  input: CreateWidgetIntegrationPushAppyInput;
  storecastId: string;
};
export type WAPushAppyMutation$data = {
  readonly dashboard: {
    readonly createWidgetIntegrationPushAppy: {
      readonly id: string;
    };
  };
};
export type WAPushAppyMutation = {
  response: WAPushAppyMutation$data;
  variables: WAPushAppyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetIntegrationPushAppy",
        "kind": "LinkedField",
        "name": "createWidgetIntegrationPushAppy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAPushAppyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAPushAppyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d2002197af17216025b5a756286e8cb5",
    "id": null,
    "metadata": {},
    "name": "WAPushAppyMutation",
    "operationKind": "mutation",
    "text": "mutation WAPushAppyMutation(\n  $storecastId: ID!\n  $input: CreateWidgetIntegrationPushAppyInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetIntegrationPushAppy(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7811c33eb81d0306f2b3e1649e017661";

export default node;
